import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor } from '../../client';
import { works as portfolioWorks } from '../../data/portfolioContent';
import './Work.scss';

const filters = ['All', 'Full Stack', 'SaaS', 'Web Platforms', 'E-commerce', 'Automotive', 'Government'];

const Work = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [filterWork, setFilterWork] = useState(portfolioWorks);

  const getWorkImage = (work) => {
    if (work.image) {
      return urlFor(work.image).width(620).height(460).fit('crop').url();
    }

    return work.screenshot;
  };

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);
      setFilterWork(
        item === 'All'
          ? portfolioWorks
          : portfolioWorks.filter((work) => work.tags.includes(item)),
      );
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">Work</h2>

      <div className="app__work-filter">
        {filters.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
          >
            {item}
          </button>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work) => {
          const workImage = getWorkImage(work);

          return (
            <div className="app__work-item app__flex" key={work.title}>
              <div className="app__work-img app__flex">
                {workImage ? (
                  <img src={workImage} alt={work.title} loading="lazy" />
                ) : (
                  <div className="app__work-preview">
                    <span>{work.initials}</span>
                    <strong>{work.stack}</strong>
                  </div>
                )}
              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                className="app__work-hover app__flex"
              >
                {work.projectLink ? (
                  <a href={work.projectLink} target="_blank" rel="noreferrer" aria-label={`Open ${work.title}`}>
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.9] }}
                      transition={{ duration: 0.25 }}
                      className="app__flex"
                    >
                      <AiFillEye />
                    </motion.div>
                  </a>
                ) : null}

                {work.codeLink ? (
                  <a href={work.codeLink} target="_blank" rel="noreferrer" aria-label={`Open ${work.title} source`}>
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.9] }}
                      transition={{ duration: 0.25 }}
                      className="app__flex"
                    >
                      <AiFillGithub />
                    </motion.div>
                  </a>
                ) : null}
              </motion.div>
            </div>
            <div className="app__work-content app__flex">
              {work.projectLink ? (
                <a className="app__work-title-link" href={work.projectLink} target="_blank" rel="noreferrer">
                  <h4 className="bold-text">{work.title}</h4>
                </a>
              ) : (
                <h4 className="bold-text">{work.title}</h4>
              )}
              <p className="p-text" style={{ marginTop: 10 }}>{work.description}</p>
              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
          );
        })}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  'app__primarybg',
);
